<app-auth-modal-layout>
  @if (modalData.role === Role.Subscriber) {
    <h2 class="text-lg font-medium sm:text-xl md:text-2xl text-center">
      Login my Application(s)
    </h2>
  } @else {
    <h2 class="text-lg font-medium sm:text-xl md:text-2xl text-center">
      <fa-icon [icon]="shieldIcon"></fa-icon>
      Login to Clerk Portal
    </h2>
  }

  <form
    [appLoginSubmit]="modalData"
    autocomplete="off"
    [formGroup]="loginForm"
    class="flex flex-col gap-8">
    <div class="flex flex-col gap-1">
      <app-ccs-input
        label="Email Address"
        formControlName="username"
        placeholder="Enter your email address"
        size="md"
        [errorMessages]="ERROR_MESSAGES.email" />
    </div>
    <div class="flex flex-col gap-1">
      <app-ccs-input
        label="Password"
        formControlName="password"
        placeholder="Enter your password"
        [errorMessages]="ERROR_MESSAGES.password"
        type="password"
        size="md"
        [type]="passwordType()"
        [icon]="passwordIcon()"
        (onClickIcon)="togglePasswordVisibility()" />
      @if (modalData.role !== Role.Clerk) {
        <button
          type="button"
          class="text-left text-sm font-light mt-3"
          (click)="openForgotPassword()">
          Forgot user
          <span class="underline font-semibold cursor-pointer">Password?</span>
        </button>
      }
    </div>
    <div class="flex gap-2 sm:gap-4">
      <ui-button
        type="button"
        variant="tertiary"
        class="w-full"
        [disabled]="sending()"
        appCloseModal>
        Cancel
      </ui-button>
      <ui-button
        type="submit"
        variant="primary"
        class="w-full"
        [disabled]="loginForm.invalid || sending()">
        @if (sending()) {
          <div class="flex flex-row justify-center items-center gap-2">
            <span appIcon name="spinner" [size]="16"></span>
            Logging in
          </div>
        } @else {
          Login
        }
      </ui-button>
    </div>
  </form>
</app-auth-modal-layout>
